module.exports = __webpack_public_path__ + "c941a6999ef3275c39e3aab7c90127df.png";